import React from 'react';
import PropTypes from 'prop-types';
import { classList } from 'utils/componentsCommon';

const Tag = ( { children, color = '', href = '', ...props }) => {
    const classNames = classList(
        'tag',
        color && `color-${color}`);

    return <>
        { href === '' &&
            <div className={ classNames } { ...props }>{ children }</div>
        }

        { href !== '' &&
            <a className={ classNames } { ...props }>{ children }</a>
        }
    </>;
};

Tag.propTypes = {
    children: PropTypes.node.isRequired,
    href: PropTypes.string,
    color: PropTypes.string,
};

export default Tag;
